import { motion } from "framer-motion";
import { slideInRight } from "./animationVariants";

export default function AgentLaunchCard({ agent }) {
  return (
    <motion.div
      {...slideInRight}
      className="lg:col-span-8"
    >
      <a
        href={agent.url}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`agent-preview-${agent.id}`}
        className="group relative block rounded-2xl overflow-hidden border-2 border-primary/30 bg-card
                   h-[clamp(420px,60vh,620px)] shadow-md hover:border-primary hover:shadow-2xl
                   hover:-translate-y-0.5 transition-all"
      >
        <div className="absolute inset-0 grid place-items-center">
          <div className="text-center px-6 max-w-md">
            {agent.avatar ? (
              <img
                src={agent.avatar}
                alt=""
                className="h-24 w-24 rounded-2xl mx-auto mb-6 object-cover bg-primary/10 ring-2 ring-primary/20 group-hover:scale-105 transition-transform"
              />
            ) : (
              <div className="h-24 w-24 rounded-2xl bg-primary/10 grid place-items-center font-display text-primary text-4xl font-bold mx-auto mb-6 ring-2 ring-primary/20 group-hover:scale-105 transition-transform">
                ✓
              </div>
            )}
            <div className="eyebrow text-[0.6rem] mb-2">{agent.role}</div>
            <h2 className="font-display text-3xl md:text-4xl font-semibold mb-4 leading-tight">
              Launch {agent.name}
            </h2>
            <p className="text-base md:text-lg text-foreground/75 leading-relaxed mb-7">
              {agent.blurb}
            </p>
            <span className="iw-btn-red inline-flex items-center gap-2 px-7 py-3.5 text-[0.7rem] group-hover:gap-3 transition-all">
              {agent.cta}
              <span aria-hidden className="text-lg">→</span>
            </span>
          </div>
        </div>
      </a>
    </motion.div>
  );
}
